import React from 'react';
import ApplePayButton from '../../ApplePayButton';
import PaymentRequestButton from '../../PaymentRequestButton';
import dataAids from '../../../../constants/dataAids';
import { UX2 } from '@wsb/guac-widget-core';
import PropTypes from 'prop-types';
import { ApplePayStore } from '../../../utils/ols-core';

class CheckoutButtons extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      matchingButtonId: null,
      ...this.getStoreState()
    };
  }

  getStoreState() {
    const { inSession } = ApplePayStore.getState();
    return { inSession };
  }

  componentDidMount() {
    ApplePayStore.addListener('change', this.onStoreChange);
    this.setState({ matchingButtonId: '#addtocart-btn' });
  }

  componentWillUnmount() {
    ApplePayStore.removeListener('change', this.onStoreChange);
  }

  onStoreChange = () => {
    this.setState(this.getStoreState());
  }

  render() {
    const buttonStyles = {
      '@xs': {
        borderRadius: '5px',
        paddingLeft: 'xsmall',
        paddingRight: 'xsmall',
        paddingTop: 'small',
        paddingBottom: 'small',
        lineHeight: '18px'
      },
      '@sm': {
        paddingLeft: 'medium',
        paddingRight: 'medium'
      }
    };

    const {
      handleAddToCart,
      handleApplePayClick,
      getOrderData,
      phoneRequired,
      translate,
      renderMode,
      category,
      prices,
      applePayIsAvailable,
      requiredFieldsBlank,
      processing,
      isSelectedVariantInStock,
      isPaymentRequestEnabled,
      stackButtons
    } = this.props;
    const { Block, Button } = UX2.Element;
    const { matchingButtonId, inSession } = this.state;

    const price = prices.onSale ? prices.salePrice : prices.price;
    const showApplePayButton = applePayIsAvailable && price > 0.0;
    const isEditMode = renderMode === 'EDIT';

    const buttonProps = showApplePayButton
      ? {
        style: buttonStyles
      }
      : null;

    const noop = () => {};

    const addToCartButton = (
      <Button.Spotlight
        id='addtocart-btn'
        onClick={ isEditMode ? noop : handleAddToCart }
        state={ isSelectedVariantInStock && !requiredFieldsBlank && !inSession ? 'default' : 'disabled' }
        disabled={ processing || inSession || !isSelectedVariantInStock || requiredFieldsBlank || isEditMode }
        data-aid={ dataAids.ADD_TO_CART }
        { ...buttonProps }
        children={ translate('products.add_to_cart') }
      />
    );

    const applePayButton = (layoutMode) => {
      if (isPaymentRequestEnabled && (renderMode === 'PUBLISH' || layoutMode === 'desktop')) {
        const styles = {
          paymentRequestButton: {
            theme: category !== 'neutral' ? 'light' : 'dark',
            type: 'buy',
            height: '50px'
          }
        };
        return (
          <PaymentRequestButton
            layoutMode={ layoutMode }
            renderMode={ renderMode }
            initPage='product_detail'
            styles={ styles }
            matchingButtonId={ matchingButtonId }
            disabled={
              processing ||
              inSession ||
              !isSelectedVariantInStock ||
              requiredFieldsBlank ||
              renderMode !== 'PUBLISH'
            }
            getOrderData={ getOrderData }
            phoneRequired={ phoneRequired }
            dataAid={ dataAids.PDP_PAYMENT_REQUEST }
          />
        );
      }
      return (
        <ApplePayButton
          category={ category }
          renderMode={ renderMode }
          disabled={
            processing ||
            inSession ||
            !isSelectedVariantInStock ||
            requiredFieldsBlank ||
            renderMode !== 'PUBLISH'
          }
          onClick={ handleApplePayClick }
          data-aid={ dataAids.PDP_APPLE_PAY }
        />
      );

    };

    const styles = {
      wrapper: {
        'display': 'flex',
        'flexDirection': stackButtons ? 'column' : 'row',
        'alignItems': stackButtons ? 'flex-start' : 'center',
        '@xs-only': {
          display: 'none'
        }
      },
      addToCart: {
        marginLeft: '0',
        minWidth: showApplePayButton ? '0' : '200px'
      },
      applePayWrapper: {
        marginLeft: stackButtons ? '0' : 'medium',
        marginTop: stackButtons ? 'small' : '0',
        minWidth: '160px'
      }
    };

    return (
      <Block>
        <Block style={ styles.wrapper }>
          <Block children={ addToCartButton } style={ styles.addToCart } />
          {showApplePayButton &&
            <Block children={ applePayButton('desktop') } style={ styles.applePayWrapper } />
          }
        </Block>
        <Block style={{ marginBottom: 'large' }}>
          <Block
            style={{
              '@sm': {
                display: 'none'
              }
            }}
          >
            {showApplePayButton &&
              <Block children={ applePayButton('mobile') } style={{ marginBottom: 'small' }} />
            }
            {addToCartButton}
          </Block>
        </Block>
      </Block>
    );
  }
}

CheckoutButtons.propTypes = {
  handleAddToCart: PropTypes.func,
  handleApplePayClick: PropTypes.func,
  getOrderData: PropTypes.func,
  phoneRequired: PropTypes.bool,
  translate: PropTypes.func,
  renderMode: PropTypes.string,
  category: PropTypes.string,
  prices: PropTypes.object,
  applePayIsAvailable: PropTypes.bool,
  requiredFieldsBlank: PropTypes.bool,
  processing: PropTypes.bool,
  isSelectedVariantInStock: PropTypes.bool,
  isPaymentRequestEnabled: PropTypes.bool,
  stackButtons: PropTypes.bool
};

export default CheckoutButtons;
